import createIcon from '../../createIcon';

/**
 * @component @name Receipt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggMTdINlYxNUgxOFYxN1pNMTggMTNINlYxMUgxOFYxM1pNMTggOUg2VjdIMThWOVpNMyAyMkw0LjUgMjAuNUw2IDIyTDcuNSAyMC41TDkgMjJMMTAuNSAyMC41TDEyIDIyTDEzLjUgMjAuNUwxNSAyMkwxNi41IDIwLjVMMTggMjJMMTkuNSAyMC41TDIxIDIyVjJMMTkuNSAzLjVMMTggMkwxNi41IDMuNUwxNSAyTDEzLjUgMy41TDEyIDJMMTAuNSAzLjVMOSAyTDcuNSAzLjVMNiAyTDQuNSAzLjVMMyAyVjIyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Receipt = createIcon('Receipt', [
  [
    'path',
    {
      d: 'M18 17H6V15H18V17ZM18 13H6V11H18V13ZM18 9H6V7H18V9ZM3 22L4.5 20.5L6 22L7.5 20.5L9 22L10.5 20.5L12 22L13.5 20.5L15 22L16.5 20.5L18 22L19.5 20.5L21 22V2L19.5 3.5L18 2L16.5 3.5L15 2L13.5 3.5L12 2L10.5 3.5L9 2L7.5 3.5L6 2L4.5 3.5L3 2V22Z',
      key: '8zj4z4',
    },
  ],
]);

export default Receipt;
